"use strict";
export var DeployModes = /* @__PURE__ */ ((DeployModes2) => {
  DeployModes2["Deploy"] = "deploy";
  DeployModes2["CanaryDeploy"] = "canary-deploy";
  return DeployModes2;
})(DeployModes || {});
